import { ElementRef, QueryList } from '@angular/core';
import { findLast, isEqual } from 'lodash-es';

export class BulkActionsOverlayHelper {
  // Anchors to the row of the most recently selected item on the page (header row when none is on it).
  // Starts at the first content cell so the bar never covers the selection checkboxes.
  public static getOrigin<TId>(
    rowIds: TId[],
    selectedIds: TId[],
    rowCheckBoxes: QueryList<ElementRef<HTMLElement>>,
    headerCheckBox: ElementRef<HTMLElement>,
  ): ElementRef<HTMLElement> {
    const lastSelectedId = findLast(selectedIds, (id) => rowIds.some((rowId) => isEqual(rowId, id)));
    const rowIndex = rowIds.findIndex((rowId) => isEqual(rowId, lastSelectedId));
    const checkBox = rowCheckBoxes?.get(rowIndex) ?? headerCheckBox;
    const contentCell = checkBox?.nativeElement.closest('td, th')?.nextElementSibling as HTMLElement;
    return contentCell ? new ElementRef(contentCell) : checkBox;
  }
}
